export default "__VITE_ASSET__MAgMReaA__"